/* import __COLOCATED_TEMPLATE__ from './multi-location-select-modal.hbs.js'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { EnablementStatus } from '@square/dashboard-protos/models/squareup/channelcontrols/configuration/enums';
let MultiLocationSelectModal = (_dec = computed('args.isOpen'), _dec2 = computed('args.allLocations'), _dec3 = computed('args.modalContext', 'cashLocalProfile.{fulfillmentDeliveryEnablementByLocation,fulfillmentPickupEnablementByLocation}', 'selectedLocations.[]', 'subunits'), _class = class MultiLocationSelectModal extends Component {
  constructor(owner, args) {
    super(owner, args);
    // For pickup and delivery modals, initialize with currently enabled locations
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "dataApi", _descriptor2, this);
    _initializerDefineProperty(this, "cashLocalProfile", _descriptor3, this);
    _initializerDefineProperty(this, "selectedLocations", _descriptor4, this);
    _initializerDefineProperty(this, "isInitialized", _descriptor5, this);
    if (this.args.modalContext === 'pickup') {
      this.selectedLocations = this.cashLocalProfile.fulfillmentLocationsWithPickupEnabled;
    } else if (this.args.modalContext === 'delivery') {
      this.selectedLocations = this.cashLocalProfile.fulfillmentLocationsWithDeliveryEnabled;
    } else {
      this.selectedLocations = this.args.initialSelectedLocations;
    }
    setTimeout(() => {
      this.isInitialized = true;
    }, 0);
  }
  trackLocalProfilesEvent(activity, event, additionalParams = {}) {
    this.dataApi.track(event, {
      activity,
      event,
      feature: 'Local Profiles',
      params: {
        brand_token: this.cashLocalProfile.brandToken || '',
        event_location: this.args.eventLocation,
        num_locations: this.cashLocalProfile.locationConfigurations.length.toString(),
        ...additionalParams
      }
    });
  }
  get isModalOpen() {
    return this.args.isOpen;
  }
  get subunits() {
    return this.args.allLocations;
  }
  get locationValues() {
    return this.selectedLocations.join(',');
  }
  get modalContext() {
    return this.args.modalContext || 'ordering'; // Default to 'ordering' if not provided
  }
  get modalTitle() {
    if (this.args.modalContext === 'pickup') {
      return this.intl.t('cashAppLocal.profileDropdown.multiLocationSelectModal.pickupTitle');
    } else if (this.args.modalContext === 'delivery') {
      return this.intl.t('cashAppLocal.profileDropdown.multiLocationSelectModal.deliveryTitle');
    }
    return this.intl.t('cashAppLocal.profileDropdown.multiLocationSelectModal.title');
  }
  get primaryButtonText() {
    return this.modalContext === 'prep-time' ? this.intl.t('cashAppLocal.profileDropdown.multiLocationSelectModal.next') : this.intl.t('button.save');
  }
  get locationEnabledStates() {
    const states = {};
    const context = this.args.modalContext;
    if (!this.cashLocalProfile || !context) {
      return states;
    }
    this.subunits.forEach(subunit => {
      if (context === 'pickup') {
        states[subunit.token] = this.cashLocalProfile.fulfillmentPickupEnablementByLocation[subunit.token] === EnablementStatus.ENABLED;
      } else if (context === 'delivery') {
        states[subunit.token] = this.cashLocalProfile.fulfillmentDeliveryEnablementByLocation[subunit.token] === EnablementStatus.ENABLED;
      } else {
        // For ordering context, check if location is in the selected locations
        states[subunit.token] = this.selectedLocations.includes(subunit.token);
      }
    });
    return states;
  }
  loggingEventName(enabled) {
    if (this.modalContext === 'ordering') {
      return enabled ? 'Click Local Profile Enable Ordering' : 'Click Local Profile Disable Ordering';
    } else {
      return enabled ? 'Click Local Profile Fulfillment Modal Enable Fulfillment' : 'Click Local Profile Fulfillment Modal Disable Fulfillment';
    }
  }
  logToggleChange(subunitToken, value) {
    if (!this.isInitialized) {
      return; // Skip tracking during initialization
    }
    if (value.detail.current === value.detail.previous) {
      return; // No actual change, don't track
    }
    const additionalParams = {
      unit_tokens: subunitToken || ''
    };
    if (this.modalContext !== 'ordering') {
      additionalParams.fulfillment_type = this.modalContext;
    }
    this.trackLocalProfilesEvent('Manage Profile Fulfillment', this.loggingEventName(value.detail.current), additionalParams);
  }
  close() {
    this.args.onClose();
  }
  next() {
    if (this.modalContext === 'prep-time') {
      if (this.selectedLocations.length > 0) {
        this.args.onNext(this.selectedLocations);
      }
    } else {
      this.args.onNext();
    }
  }
  onSelectionChanged(value) {
    this.selectedLocations = value.detail.currentSelectionValues;
    this.args.updateSelectedLocations(value.detail.currentSelectionValues);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cashLocalProfile", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "selectedLocations", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isInitialized", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isModalOpen", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "isModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subunits", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "subunits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationEnabledStates", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "locationEnabledStates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "logToggleChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "logToggleChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "next", [action], Object.getOwnPropertyDescriptor(_class.prototype, "next"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSelectionChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelectionChanged"), _class.prototype), _class);
export { MultiLocationSelectModal as default };